<template>
  <div class="lime-body">
    <div class="container">
      <div class="row">
      <loading :active.sync="isLoading" 
                :can-cancel="true" 
                :is-full-page="fullPage"></loading>
        <div class="col-md-4 offset-md-4">
          <div class="card profile">
            <div class="card-body ">
              <h5 class="card-title center">Account Setting</h5>
              <form action="#" v-on:keyup.enter="update()">
              <p style="color:red;text-align:center">{{ errorMessage }}</p>
              <p v-if="errors.length">
                
                <p style='color:red;text-align:center' v-for="error in errors"> {{ error }}</p>
              </p>
                <flash-message class="myCustomClass"></flash-message>
                <div class="admin-logo">
                  <img v-bind:src=" siteLogo ">
                </div>
                <div class="form-group">
                  <input class="form-control" type="file" name="ghost_logo" ref="fileaddacct" id="fileaddacct" v-on:change="handleFileUpload()" />
                </div>
                <div class="form-group">
                  <input class="form-control" ref="ghost_name" type="text" name="ghost_name" v-model="ghostName" id="ghost_name" placeholder="Ghost Name" />
                </div>
                <div class="form-group">
                  <input class="form-control" ref="email" type="text" name="email" v-model="ghostEmail"  placeholder="Email" id="email" />
                </div>
                <input type="button" class="btn btn-primary" v-on:click="update()" value="save" />
                <!-- <button class="btn btn-secondary">Cancel</button> -->
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  require('vue-flash-message/dist/vue-flash-message.min.css')
  export default {
    name: 'account-setting',
    components: {
      Loading
    },
    data () {
      return {
        errors: [],
        isLoading: false,
        fullPage: true,
        errorMessage: '',
        input: {
          email: localStorage.getItem('useremail'),
          ghost_name: localStorage.getItem('username')
        },
        file: '',
        ghostlogo: localStorage.getItem('account_image'),
        siteLogo: '',
        ghostName: '',
        ghostEmail: ''

      }
    },
    methods: {
      update () {
        this.errors = []
        var fuData = document.getElementById('fileaddacct')
        var FileUploadPath = fuData.value
        var ext = FileUploadPath.substring(FileUploadPath.lastIndexOf('.') + 1).toLowerCase()
        var jwttoken = localStorage.getItem('jwt')
        if (FileUploadPath === '') {
          this.errors.push('File is Required')
        } else if (!this.checkExtension(ext)) {
          this.errors.push('Only jpeg , png , gif Allowed')
        } else if (this.ghostName === '') {
          this.errors.push('Ghost Name is Required')
          this.$refs.ghost_name.focus()
        } else if (this.ghostName.length < 3) {
          this.errors.push('Ghost Name must be 3 characters long')
          this.$refs.ghost_name.focus()
        } else if (this.ghostEmail === '') {
          this.errors.push('Email is Required')
          this.$refs.email.focus()
        } else if (!this.emailValidator.validate(this.ghostEmail)) {
          this.errors.push('Invalid Ghost Email')
          this.$refs.email.focus()
        }  
        else {
          let formData = new FormData()
          formData.append('email', this.ghostEmail)
          formData.append('ghost_name', this.ghostName)
          formData.append('file', this.fileaddacct)
          this.isLoading = true
          axios.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/accountSetting',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
                'x-access-token': jwttoken
              }
            }
          ).then(response => {
            // console.log(response)
            localStorage.setItem('ghost_logo', response.data.results[0].ghost_logo)
            this.isLoading = false
            // console.log(response)
            this.flash('Account Setting Updated Successfully', 'success', {
              timeout: 1000,
              beforeDestroy () {
                location.reload()
              }
            })
          })
            .catch((error) => {
              this.errorMessage = error.response.data.errors
              this.isLoading = false
            })
        }
      },
      handleFileUpload () {
        this.fileaddacct = this.$refs.fileaddacct.files[0]
      },
      showLogo () {
        var jwttoken = localStorage.getItem('jwt')
        this.isLoading = true
        axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getaccountSetting', {
          headers: {
            'x-access-token': jwttoken
          }})
          .then(response => {
            this.isLoading = false
            this.siteLogo = response.data.results[0].ghost_logo
            this.ghostName = response.data.results[0].ghost_name
            this.ghostEmail = response.data.results[0].email
          })
          .catch((error) => {
            this.errorMessage = error.response.data.errors
            this.isLoading = false
          })
      }
    },
    mounted () {
      this.showLogo()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/AccountSetting.vue